module.exports = __webpack_public_path__ + "img/19451038002403.bfd67ff0.png";